/**
 * Cevrimdisi check-in kuyrugu (IndexedDB).
 *
 * Internet kesildiginde check-in kaybolmaz: istek burada saklanir, baglanti
 * gelince `Idempotency-Key` ile aynen gonderilir. Ayni kayit iki kez islenmez.
 */
const VT_ADI = 'hotelcms';
const DEPO = 'bekleyen-checkin';

export interface BekleyenIstek {
  id: string;
  yol: string;
  govde: unknown;
  olusturmaAni: number;
  deneme: number;
}

function vt(): Promise<IDBDatabase> {
  return new Promise((coz, red) => {
    const istek = indexedDB.open(VT_ADI, 1);
    istek.onupgradeneeded = () => {
      const db = istek.result;
      if (!db.objectStoreNames.contains(DEPO)) db.createObjectStore(DEPO, { keyPath: 'id' });
    };
    istek.onsuccess = () => coz(istek.result);
    istek.onerror = () => red(istek.error);
  });
}

async function islem<T>(mod: IDBTransactionMode, is: (depo: IDBObjectStore) => IDBRequest<T>): Promise<T> {
  const db = await vt();
  return new Promise((coz, red) => {
    const t = db.transaction(DEPO, mod);
    const istek = is(t.objectStore(DEPO));
    istek.onsuccess = () => coz(istek.result);
    istek.onerror = () => red(istek.error);
  });
}

export function yeniIstekId(): string {
  return `${Date.now().toString(36)}-${crypto.randomUUID().slice(0, 8)}`;
}

export async function kuyrugaEkle(kayit: Omit<BekleyenIstek, 'deneme'>): Promise<void> {
  await islem('readwrite', (d) => d.put({ ...kayit, deneme: 0 }));
}

export async function kuyruguOku(): Promise<BekleyenIstek[]> {
  return islem<BekleyenIstek[]>('readonly', (d) => d.getAll() as IDBRequest<BekleyenIstek[]>);
}

export async function kuyruktanSil(id: string): Promise<void> {
  await islem('readwrite', (d) => d.delete(id));
}

export async function denemeArttir(kayit: BekleyenIstek): Promise<void> {
  await islem('readwrite', (d) => d.put({ ...kayit, deneme: kayit.deneme + 1 }));
}
